"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Guard = void 0;
var assert_1 = require("./utils/assert");
var VALUE_TYPE = Symbol();
var Guard = /** @class */ (function () {
    function Guard(args) {
        var type = args.type, coerce = args.coerce, validate = args.validate, convert = args.convert, scan = args.scan, substitute = args.substitute;
        this.type = type !== null && type !== void 0 ? type : this.constructor.name;
        var guard = this;
        var coercer = coerce === undefined
            ? function (path, value, _coercer) { return _coercer(guard, path, value); }
            : function (path, value, _coercer) {
                var coercedValue = _coercer(guard, path, value);
                return coerce(path, coercedValue, _coercer);
            };
        this.coerce = coercer;
        this.validate = validate;
        var converter = convert === undefined
            ? function (path, value, _converter) {
                var iterator = validate(path, value);
                var _a = iterator.next(), valueIsValid = _a.done, invalidation = _a.value;
                if (valueIsValid !== true) {
                    var invalidations = __spreadArray([invalidation], __read(iterator), false);
                    throw new assert_1.AssertionError(invalidations);
                }
                return _converter(guard, path, value);
            }
            : function (path, value, _converter) {
                var iterator = validate(path, value);
                var _a = iterator.next(), valueIsValid = _a.done, invalidation = _a.value;
                if (valueIsValid !== true) {
                    var invalidations = __spreadArray([invalidation], __read(iterator), false);
                    throw new assert_1.AssertionError(invalidations);
                }
                var convertedValue = _converter(guard, path, value);
                var done = validate(path, convertedValue).next().done;
                if (done === true) {
                    return convert(path, convertedValue, _converter);
                }
                else {
                    return convertedValue;
                }
            };
        this.convert = converter;
        var scanner = scan === undefined
            ? function (path, value, _scanner) {
                var iterator, valueIsValid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            iterator = validate(path, value);
                            valueIsValid = iterator.next().done;
                            if (!valueIsValid) return [3 /*break*/, 2];
                            return [5 /*yield**/, __values(_scanner(guard, path, value))];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }
            : function (path, value, _scanner) {
                var iterator, valueIsValid;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            iterator = validate(path, value);
                            valueIsValid = iterator.next().done;
                            if (!valueIsValid) return [3 /*break*/, 3];
                            return [5 /*yield**/, __values(_scanner(guard, path, value))];
                        case 1:
                            _a.sent();
                            return [5 /*yield**/, __values(scan(path, value, _scanner))];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            };
        this.scan = scanner;
        var replacer = substitute === undefined
            ? function (path, _replacer) { return _replacer(guard, path); }
            : function (path, _replacer) {
                var replacement = _replacer(guard, path);
                return replacement === guard ? substitute(path, _replacer) : replacement;
            };
        this.substitute = replacer;
    }
    Object.defineProperty(Guard.prototype, VALUE_TYPE, {
        // match og convert kan benytte Output, og derved kan denne prop smides væk
        get: function () {
            // Hack to conform TypeScript and keep Output exposed
            throw new Error('Cannot be used - ensures "Output" exists on a derived class');
        },
        enumerable: false,
        configurable: true
    });
    return Guard;
}());
exports.Guard = Guard;
